import React from "react";

export default function PrivacyPolicy() {
  const effectiveDate = "2025-10-11";
  const lastUpdated = "2025-10-11";

  return (
    <main className="min-h-screen bg-gray-50 text-gray-900 py-12">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-8 sm:p-12">
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold">
            Privacy Policy
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Website:{" "}
            <a href="https://aiengrimran.netlify.app" className="underline">
              aiengrimran.netlify.app
            </a>
          </p>
          <div className="mt-4 text-xs text-gray-500">
            Effective Date: {effectiveDate} • Last Updated: {lastUpdated}
          </div>
        </header>

        <article className="prose prose-neutral max-w-none">
          <section>
            <h2>1. Introduction</h2>
            <p>
              We respect your privacy and are committed to protecting your
              personal data. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you interact with us
              via WhatsApp Business Cloud API, or through our Site. By using our
              services, you agree to the collection and use of information in
              accordance with this policy.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <ul>
              <li>
                <strong>Contact information</strong> — for example, your name,
                phone number, WhatsApp user ID, or any information you provide
                in messages.
              </li>
              <li>
                <strong>Profile data</strong> — like your profile name, profile
                picture if visible/used, or any public profile info.
              </li>
              <li>
                <strong>Message content</strong> — the content of messages you
                send to us via WhatsApp (questions, requests, feedback).
              </li>
              <li>
                <strong>Usage data</strong> — logs, timestamps, metadata (when
                messages are sent, received, device type, IP address) to help
                maintain the service, detect misuse, etc.
              </li>
              <li>
                <strong>Cookies and analytics data</strong> on the Site — e.g.
                how you visited, pages viewed, etc.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect for purposes including:</p>
            <ul>
              <li>To respond to your inquiries via WhatsApp.</li>
              <li>To provide you with services or information you request.</li>
              <li>To verify your identity if needed.</li>
              <li>
                To maintain, secure, and improve our services, including
                troubleshooting or preventing abuse.
              </li>
              <li>
                To send you updates or notifications relevant to your
                interactions (if you consent).
              </li>
            </ul>
          </section>

          <section>
            <h2>4. WhatsApp Business Cloud API Specifics</h2>
            <p>
              Because we use WhatsApp Business Cloud API, messages exchanged are
              stored/transmitted through Meta infrastructure. We do not access
              or use them beyond what is required to provide you the service. We
              do not sell your personal data to third parties.
            </p>
          </section>

          <section>
            <h2>5. Data Sharing &amp; Disclosure</h2>
            <p>We may share your data under these circumstances:</p>
            <ul>
              <li>
                With trusted third-party service providers who assist us in
                delivering the service (e.g. hosting, analytics, messaging
                infrastructure), subject to strict confidentiality.
              </li>
              <li>If required by law (court orders, regulators).</li>
              <li>
                To protect rights, property, safety of ourselves or others (e.g.
                in case of abuse, fraud).
              </li>
            </ul>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We keep your information only for as long as needed for the
              purposes in this policy, or as required by law. If you ask us to
              delete your data (to the extent permissible under law), we will do
              so, unless there is a legitimate reason to retain it (e.g. legal
              requirements, dispute resolution).
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>
              Depending on your jurisdiction, you may have rights such as
              accessing, correcting, deleting your personal data, or withdrawing
              consent for certain uses. To exercise any rights, contact us via
              the details below.
            </p>
          </section>

          <section>
            <h2>8. Security</h2>
            <p>
              We use reasonable organizational, technical, and administrative
              safeguards to protect your information. However, as with any
              online system, there is always some risk. You use the service at
              your own risk.
            </p>
          </section>

          <section>
            <h2>9. Children</h2>
            <p>
              Our services are not intended for children under the applicable
              age (e.g. 13 or 16 depending on jurisdiction). We do not knowingly
              collect or solicit personal data from children. If you believe we
              have collected a child’s data, contact us and we will work to
              remove that data.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this policy from time to time. When we do, we will
              change the “Last Updated” date. We encourage you to check this
              page periodically for changes.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this policy, or want to exercise
              any of your rights, contact:
            </p>
            <address>
              <strong>Muhammad Imran</strong>
              <br />
              Email:{" "}
              <a href="mailto:aiengrimran@gmail.com">aiengrimran@gmail.com</a>
              <br />
              Phone / WhatsApp: +92 336 9626425
              <br />
              Address: Islamabad, Pakistan
            </address>
          </section>

          <footer className="mt-8 text-sm text-gray-500">
            <p>
              This privacy policy is a general-purpose template adapted for use
              with WhatsApp Business Cloud API. It does not constitute legal
              advice. For full legal compliance (e.g., GDPR, PDPA), consult a
              qualified attorney.
            </p>
          </footer>
        </article>
      </div>
    </main>
  );
}
